<div
  class="buttonsSectionWrapper"
>
  <div
    *ngIf="notificationIsVisible"
    class='simpleNotificationStyle'
  >
    {{notificationText()}}
  </div>
  <div
    class="buttonsContainer"
  >
    <button
      [ngClass]="createSaveButtonStyle()"
      (click)="saveCreateButtonClickHandler()"
    >
      {{createSaveButtonName()}}
    </button>
    <button
      class="declineButtonStyle"
      (click)="cancelClickHandler()"
    >
      {{declineButtonName}}
    </button>
  </div>
</div>
